import * as t from "io-ts";
import nullable from "./nullable";
export const driverInvoiceLinesRevisionChangedT = t.strict({
    deliveryId: t.string,
    revisionNumber: t.string,
});
export const createDriverInvoiceLinesTypes = ({ decimalT, }) => {
    const createUpdateLineT = t.intersection([
        t.type({
            productId: nullable(t.string),
            description: nullable(t.string),
            unitId: nullable(t.string),
            quantity: decimalT,
        }),
        t.partial({
            pricingAgreementId: nullable(t.string),
        }),
    ]);
    const lineT = t.type({
        id: t.string,
        productId: nullable(t.string),
        unitId: nullable(t.string),
        description: nullable(t.string),
        quantity: decimalT,
        locked: t.boolean,
    });
    const linesWithRevisionT = t.strict({
        revisionNumber: t.string,
        hasChanged: t.boolean,
        lines: nullable(t.array(lineT)),
    });
    const linesT = t.array(lineT);
    return {
        createUpdateLineT,
        lineT,
        linesT,
        linesWithRevisionT,
    };
};
//# sourceMappingURL=driver-invoice-lines.js.map